import {
  type Action,
  configureStore,
  type ThunkAction,
} from "@reduxjs/toolkit";

import entriesGeneratorReducer from "./slices/entriesGeneratorSlice";
import entryReducer from "./slices/entrySlice";
import generatorFeaturesSlice from "./slices/generatorFeaturesSlice";
import generatorSlice from "./slices/generatorSlice";
import managementReducer from "./slices/managementSlice";
import medicalHistoryReducer from "./slices/medicalHistorySlice";
import organizeReducer from "./slices/organizeSlice";
import pendingRequestsReducer from "./slices/pendingRequestsSlice";
import permsReducer from "./slices/permsSlice";
import preferencesReducer from "./slices/preferencesSlice";
import searchReducer from "./slices/searchSlice";
import verifyReducer from "./slices/verifySlice";

export const store = configureStore({
  reducer: {
    preferencesSlice: preferencesReducer,
    generatorSlice,
    organizeSlice: organizeReducer,
    entriesGeneratorSlice: entriesGeneratorReducer,
    entrySlice: entryReducer,
    verifySlice: verifyReducer,
    pendingRequestsSlice: pendingRequestsReducer,
    permsSlice: permsReducer,
    searchSlice: searchReducer,
    medicalHistory: medicalHistoryReducer,
    managementSlice: managementReducer,
    generatorFeaturesSlice,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore specific action types
        ignoredActions: [
          "generatorFeaturesSlice/setIlModalData",
          "generatorFeaturesSlice/setUnitConverterModalData",
          "generatorFeaturesSlice/setTimeInputPopup",
        ],
        // Ignore specific state paths
        ignoredPaths: [
          "generatorFeaturesSlice.ilModalData.changeCellValue",
          "generatorFeaturesSlice.unitConverterModalData.onChange",
          "generatorFeaturesSlice.timeInputPopup.onChange",
        ],
      },
    }),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
